module.exports = __webpack_public_path__ + "static/media/03_Partybox_1000.341df119.png";